var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useCallback, useRef, useState, useMemo } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import useSWR from "swr";
import { process } from "../../Process";
import { BannerType, } from "ee-nestjs-interfaces";
import { Auth0Fetcher, PaginatedTable, StyledButton, StyledButtonStyle, TextInput, } from "ee-react-components";
import { Disclosure } from "@headlessui/react";
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/24/solid";
/**
 * NOC-only component for managing global and organization-level banners.
 */
export var GlobalOrgBannerManagement = function () {
    var _a = useAuth0(), getAccessTokenSilently = _a.getAccessTokenSilently, isLoading = _a.isLoading, isAuthenticated = _a.isAuthenticated;
    var organizations = useSWR(isLoading || !isAuthenticated
        ? null
        : [
            "".concat(process.env.NOC_SVC_URL, "/organizations/listall"),
            getAccessTokenSilently,
        ], Auth0Fetcher).data;
    return (React.createElement("div", { className: "flex flex-col gap-y-[32px]" },
        React.createElement("label", { className: "font-N5 text-white" }, "Global & Organization Banners"),
        React.createElement(GlobalBannerSection, null),
        React.createElement("hr", { className: "border-black-800" }),
        React.createElement(OrganizationBannerSection, { organizations: organizations !== null && organizations !== void 0 ? organizations : [] })));
};
var dateToInputString = function (date) {
    date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
    return date.toISOString().slice(0, 16);
};
var endPresets = [
    { title: "1 hour", value: 1000 * 60 * 60 },
    { title: "4 hours", value: 1000 * 60 * 60 * 4 },
    { title: "1 day", value: 1000 * 60 * 60 * 24 },
    { title: "3 days", value: 1000 * 60 * 60 * 24 * 3 },
    { title: "1 week", value: 1000 * 60 * 60 * 24 * 7 },
];
var GlobalBannerSection = function () {
    var getAccessTokenSilently = useAuth0().getAccessTokenSilently;
    var startRef = useRef(null);
    var endRef = useRef(null);
    var messageRef = useRef(null);
    var _a = useState(BannerType.INCIDENT), bannerType = _a[0], setBannerType = _a[1];
    var _b = useState(0), refreshCounter = _b[0], setRefreshCounter = _b[1];
    var onPresetClick = function (ms) {
        var _a;
        if (!endRef.current)
            return;
        var base = ((_a = startRef.current) === null || _a === void 0 ? void 0 : _a.value)
            ? new Date(startRef.current.value)
            : new Date();
        base.setMilliseconds(base.getMilliseconds() + ms);
        endRef.current.value = dateToInputString(base);
    };
    var handleDelete = useCallback(function (bannerId) { return __awaiter(void 0, void 0, void 0, function () {
        var accessToken;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getAccessTokenSilently({
                        authorizationParams: { audience: process.env.AUTH0_AUDIENCE },
                    })];
                case 1:
                    accessToken = _a.sent();
                    return [4 /*yield*/, fetch("".concat(process.env.CORE_SVC_URL, "/banners/").concat(bannerId), {
                            method: "DELETE",
                            headers: { authorization: "Bearer ".concat(accessToken) },
                        })];
                case 2:
                    _a.sent();
                    setRefreshCounter(function (c) { return c + 1; });
                    return [2 /*return*/];
            }
        });
    }); }, [getAccessTokenSilently]);
    var handleCreate = function () { return __awaiter(void 0, void 0, void 0, function () {
        var body, accessToken;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!((_a = messageRef.current) === null || _a === void 0 ? void 0 : _a.value) || !((_b = startRef.current) === null || _b === void 0 ? void 0 : _b.value))
                        return [2 /*return*/];
                    body = {
                        message: messageRef.current.value,
                        bannerType: bannerType,
                        start: new Date(startRef.current.value),
                    };
                    if ((_c = endRef.current) === null || _c === void 0 ? void 0 : _c.value) {
                        body.end = new Date(endRef.current.value);
                    }
                    return [4 /*yield*/, getAccessTokenSilently({
                            authorizationParams: { audience: process.env.AUTH0_AUDIENCE },
                        })];
                case 1:
                    accessToken = _d.sent();
                    return [4 /*yield*/, fetch("".concat(process.env.CORE_SVC_URL, "/banners/global"), {
                            method: "POST",
                            body: JSON.stringify(body),
                            headers: {
                                "Content-Type": "application/json",
                                authorization: "Bearer ".concat(accessToken),
                            },
                        })];
                case 2:
                    _d.sent();
                    if (messageRef.current)
                        messageRef.current.value = "";
                    if (startRef.current)
                        startRef.current.value = dateToInputString(new Date());
                    if (endRef.current)
                        endRef.current.value = "";
                    setBannerType(BannerType.INCIDENT);
                    setRefreshCounter(function (c) { return c + 1; });
                    return [2 /*return*/];
            }
        });
    }); };
    var columnDefinitions = useMemo(function () { return [
        { header: "Type", accessorKey: "bannerType" },
        { header: "Message", accessorKey: "message" },
        {
            header: "Start",
            accessorFn: function (row) { return new Date(row.start).toLocaleString(); },
        },
        {
            header: "End",
            accessorFn: function (row) { return new Date(row.end).toLocaleString(); },
        },
        { header: "Created By", accessorKey: "username" },
        {
            header: "Status",
            accessorKey: "status",
            cell: function (_a) {
                var row = _a.row;
                var now = new Date();
                var isActive = new Date(row.original.start) <= now &&
                    new Date(row.original.end) > now;
                return (React.createElement("span", { className: isActive ? "text-green-400" : "text-black-500" }, isActive ? "Active" : "Expired"));
            },
        },
        {
            header: "",
            accessorKey: "actions",
            cell: function (_a) {
                var row = _a.row;
                var now = new Date();
                var isActive = new Date(row.original.start) <= now &&
                    new Date(row.original.end) > now;
                return isActive ? (React.createElement(StyledButton, { text: "EXPIRE", style: StyledButtonStyle.Gray, onClick: function () { return handleDelete(row.original.id); } })) : null;
            },
        },
    ]; }, [handleDelete]);
    return (React.createElement(Disclosure, { defaultOpen: true }, function (_a) {
        var open = _a.open;
        return (React.createElement(React.Fragment, null,
            React.createElement(Disclosure.Button, { className: "bg-black-1000 hover:bg-black-800 rounded-[10px] px-[32px] py-[16px] flex flex-row gap-x-[32px] w-full justify-between" },
                React.createElement("label", { className: "font-N6" }, "Global Banners"),
                open ? (React.createElement(ChevronDownIcon, { className: "w-[32px] h-[32px]" })) : (React.createElement(ChevronUpIcon, { className: "w-[32px] h-[32px]" }))),
            React.createElement(Disclosure.Panel, { className: "w-full" },
                React.createElement("div", { className: "flex flex-col gap-y-[16px] pt-[16px]" },
                    React.createElement(PaginatedTable, { baseUrl: "".concat(process.env.CORE_SVC_URL, "/banners/global/history?_refresh=").concat(refreshCounter), itemsPerPage: 10, rowsFromResponse: function (r) { return r.banners; }, rowCountFromResponse: function (r) { return r.pages; }, columnDefinitions: columnDefinitions }),
                    React.createElement("hr", { className: "border-black-800 max-w-[50%] my-4" }),
                    React.createElement("label", { className: "font-N7 text-white" }, "Create New Global Banner"),
                    React.createElement("div", { className: "grid grid-cols-2 gap-x-4 gap-y-4 items-start max-w-[650px]" },
                        React.createElement("label", { className: "font-N7 text-white" }, "Banner Type:"),
                        React.createElement("select", { value: bannerType, onChange: function (e) { return setBannerType(e.target.value); }, className: "bg-black-900 border border-black-600 rounded p-2 text-white font-N7" },
                            React.createElement("option", { value: BannerType.INCIDENT }, "Incident"),
                            React.createElement("option", { value: BannerType.INFORMATIONAL }, "Informational"),
                            React.createElement("option", { value: BannerType.MARKETING }, "Marketing")),
                        React.createElement("label", { className: "font-N7 text-white" }, "Message:"),
                        React.createElement("textarea", { ref: messageRef, className: "bg-black-900 border border-black-600 rounded p-2 text-white font-N7 resize-y min-h-[80px]", placeholder: "Global announcement message..." }),
                        React.createElement("label", { className: "font-N7 text-white" }, "Start:"),
                        React.createElement(TextInput, { type: "datetime-local", ref: startRef, defaultValue: dateToInputString(new Date()) }),
                        React.createElement("label", { className: "font-N7 text-white" }, "End (optional):"),
                        React.createElement(TextInput, { type: "datetime-local", ref: endRef }),
                        React.createElement("div", { className: "col-span-2 text-black-500 font-N8 italic" }, "If no end date is specified, banner will auto-expire 1 month from start date."),
                        React.createElement("div", { className: "flex flex-row flex-wrap col-span-2 gap-4 items-center" },
                            React.createElement("label", { className: "font-N8 text-white" }, "End Presets:"),
                            endPresets.map(function (p, i) { return (React.createElement(StyledButton, { key: i, text: p.title, onClick: function () { return onPresetClick(p.value); } })); }))),
                    React.createElement(StyledButton, { text: "CREATE", className: "mt-4", style: StyledButtonStyle.Green, onClick: handleCreate })))));
    }));
};
var OrganizationBannerSection = function (_a) {
    var organizations = _a.organizations;
    var getAccessTokenSilently = useAuth0().getAccessTokenSilently;
    var startRef = useRef(null);
    var endRef = useRef(null);
    var messageRef = useRef(null);
    var _b = useState(BannerType.INCIDENT), bannerType = _b[0], setBannerType = _b[1];
    var _c = useState(null), selectedOrgId = _c[0], setSelectedOrgId = _c[1];
    var _d = useState(0), refreshCounter = _d[0], setRefreshCounter = _d[1];
    var onPresetClick = function (ms) {
        var _a;
        if (!endRef.current)
            return;
        var base = ((_a = startRef.current) === null || _a === void 0 ? void 0 : _a.value)
            ? new Date(startRef.current.value)
            : new Date();
        base.setMilliseconds(base.getMilliseconds() + ms);
        endRef.current.value = dateToInputString(base);
    };
    var handleDelete = useCallback(function (bannerId) { return __awaiter(void 0, void 0, void 0, function () {
        var accessToken;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getAccessTokenSilently({
                        authorizationParams: { audience: process.env.AUTH0_AUDIENCE },
                    })];
                case 1:
                    accessToken = _a.sent();
                    return [4 /*yield*/, fetch("".concat(process.env.CORE_SVC_URL, "/banners/").concat(bannerId), {
                            method: "DELETE",
                            headers: { authorization: "Bearer ".concat(accessToken) },
                        })];
                case 2:
                    _a.sent();
                    setRefreshCounter(function (c) { return c + 1; });
                    return [2 /*return*/];
            }
        });
    }); }, [getAccessTokenSilently]);
    var handleCreate = function () { return __awaiter(void 0, void 0, void 0, function () {
        var body, accessToken;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!((_a = messageRef.current) === null || _a === void 0 ? void 0 : _a.value) ||
                        !((_b = startRef.current) === null || _b === void 0 ? void 0 : _b.value) ||
                        !selectedOrgId)
                        return [2 /*return*/];
                    body = {
                        message: messageRef.current.value,
                        bannerType: bannerType,
                        start: new Date(startRef.current.value),
                    };
                    if ((_c = endRef.current) === null || _c === void 0 ? void 0 : _c.value) {
                        body.end = new Date(endRef.current.value);
                    }
                    return [4 /*yield*/, getAccessTokenSilently({
                            authorizationParams: { audience: process.env.AUTH0_AUDIENCE },
                        })];
                case 1:
                    accessToken = _d.sent();
                    return [4 /*yield*/, fetch("".concat(process.env.CORE_SVC_URL, "/banners/organization/").concat(selectedOrgId), {
                            method: "POST",
                            body: JSON.stringify(body),
                            headers: {
                                "Content-Type": "application/json",
                                authorization: "Bearer ".concat(accessToken),
                            },
                        })];
                case 2:
                    _d.sent();
                    if (messageRef.current)
                        messageRef.current.value = "";
                    if (startRef.current)
                        startRef.current.value = dateToInputString(new Date());
                    if (endRef.current)
                        endRef.current.value = "";
                    setBannerType(BannerType.INCIDENT);
                    setRefreshCounter(function (c) { return c + 1; });
                    return [2 /*return*/];
            }
        });
    }); };
    var columnDefinitions = useMemo(function () { return [
        {
            header: "Organization",
            accessorKey: "organizationId",
            cell: function (_a) {
                var row = _a.row;
                var org = organizations.find(function (o) { return o.id === row.original.organizationId; });
                return (org === null || org === void 0 ? void 0 : org.name) || "Org ".concat(row.original.organizationId);
            },
        },
        { header: "Type", accessorKey: "bannerType" },
        { header: "Message", accessorKey: "message" },
        {
            header: "Start",
            accessorFn: function (row) { return new Date(row.start).toLocaleString(); },
        },
        {
            header: "End",
            accessorFn: function (row) { return new Date(row.end).toLocaleString(); },
        },
        { header: "Created By", accessorKey: "username" },
        {
            header: "Status",
            accessorKey: "status",
            cell: function (_a) {
                var row = _a.row;
                var now = new Date();
                var isActive = new Date(row.original.start) <= now &&
                    new Date(row.original.end) > now;
                return (React.createElement("span", { className: isActive ? "text-green-400" : "text-black-500" }, isActive ? "Active" : "Expired"));
            },
        },
        {
            header: "",
            accessorKey: "actions",
            cell: function (_a) {
                var row = _a.row;
                var now = new Date();
                var isActive = new Date(row.original.start) <= now &&
                    new Date(row.original.end) > now;
                return isActive ? (React.createElement(StyledButton, { text: "EXPIRE", style: StyledButtonStyle.Gray, onClick: function () { return handleDelete(row.original.id); } })) : null;
            },
        },
    ]; }, [handleDelete, organizations]);
    return (React.createElement(Disclosure, { defaultOpen: true }, function (_a) {
        var open = _a.open;
        return (React.createElement(React.Fragment, null,
            React.createElement(Disclosure.Button, { className: "bg-black-1000 hover:bg-black-800 rounded-[10px] px-[32px] py-[16px] flex flex-row gap-x-[32px] w-full justify-between" },
                React.createElement("label", { className: "font-N6" }, "Organization Banners"),
                open ? (React.createElement(ChevronDownIcon, { className: "w-[32px] h-[32px]" })) : (React.createElement(ChevronUpIcon, { className: "w-[32px] h-[32px]" }))),
            React.createElement(Disclosure.Panel, { className: "w-full" },
                React.createElement("div", { className: "flex flex-col gap-y-[16px] pt-[16px]" },
                    React.createElement(PaginatedTable, { baseUrl: "".concat(process.env.CORE_SVC_URL, "/banners/organization/history?_refresh=").concat(refreshCounter), itemsPerPage: 10, rowsFromResponse: function (r) { return r.banners; }, rowCountFromResponse: function (r) { return r.pages; }, columnDefinitions: columnDefinitions }),
                    React.createElement("hr", { className: "border-black-800 max-w-[50%] my-4" }),
                    React.createElement("label", { className: "font-N7 text-white" }, "Create New Organization Banner"),
                    React.createElement("div", { className: "grid grid-cols-2 gap-x-4 gap-y-4 items-start max-w-[650px]" },
                        React.createElement("label", { className: "font-N7 text-white" }, "Organization:"),
                        React.createElement("select", { value: selectedOrgId !== null && selectedOrgId !== void 0 ? selectedOrgId : "", onChange: function (e) { return setSelectedOrgId(Number(e.target.value)); }, className: "bg-black-900 border border-black-600 rounded p-2 text-white font-N7" },
                            React.createElement("option", { value: "" }, "Select Organization"),
                            organizations.map(function (org) { return (React.createElement("option", { key: org.id, value: org.id },
                                org.name,
                                " (ID: ",
                                org.id,
                                ")")); })),
                        React.createElement("label", { className: "font-N7 text-white" }, "Banner Type:"),
                        React.createElement("select", { value: bannerType, onChange: function (e) { return setBannerType(e.target.value); }, className: "bg-black-900 border border-black-600 rounded p-2 text-white font-N7" },
                            React.createElement("option", { value: BannerType.INCIDENT }, "Incident"),
                            React.createElement("option", { value: BannerType.INFORMATIONAL }, "Informational"),
                            React.createElement("option", { value: BannerType.MARKETING }, "Marketing")),
                        React.createElement("label", { className: "font-N7 text-white" }, "Message:"),
                        React.createElement("textarea", { ref: messageRef, className: "bg-black-900 border border-black-600 rounded p-2 text-white font-N7 resize-y min-h-[80px]", placeholder: "Organization announcement message..." }),
                        React.createElement("label", { className: "font-N7 text-white" }, "Start:"),
                        React.createElement(TextInput, { type: "datetime-local", ref: startRef, defaultValue: dateToInputString(new Date()) }),
                        React.createElement("label", { className: "font-N7 text-white" }, "End (optional):"),
                        React.createElement(TextInput, { type: "datetime-local", ref: endRef }),
                        React.createElement("div", { className: "col-span-2 text-black-500 font-N8 italic" }, "If no end date is specified, banner will auto-expire 1 month from start date."),
                        React.createElement("div", { className: "flex flex-row flex-wrap col-span-2 gap-4 items-center" },
                            React.createElement("label", { className: "font-N8 text-white" }, "End Presets:"),
                            endPresets.map(function (p, i) { return (React.createElement(StyledButton, { key: i, text: p.title, onClick: function () { return onPresetClick(p.value); } })); }))),
                    React.createElement(StyledButton, { text: "CREATE", className: "mt-4", style: StyledButtonStyle.Green, onClick: handleCreate })))));
    }));
};
